import { Link } from 'react-router-dom';
import SEO from '../shared/SEO';
import { FAQ_ITEMS, WHATSAPP_MESSAGE, WHATSAPP_NUMBER } from '../../config/siteContent';

const WhatsAppCta = ({ label = 'Consultar por WhatsApp' }) => (
  <a
    className="info-page-cta"
    href={`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`}
    target="_blank"
    rel="noopener noreferrer"
  >
    <i className="fa-brands fa-whatsapp" aria-hidden="true" />
    {label}
  </a>
);

export const AboutPage = () => (
  <>
    <SEO
      title="Nosotros"
      description="Conocé Rem Urban Clothes, fabricantes uruguayos de indumentaria urbana y deportiva para mujer, hombre y niños."
      url="/nosotros"
      breadcrumbs={[
        { name: 'Inicio', url: '/' },
        { name: 'Nosotros', url: '/nosotros' }
      ]}
    />
    <main className="info-page">
      <section className="info-page-content">
        <p className="info-page-eyebrow">Rem Urban Clothes</p>
        <h1>Indumentaria urbana y deportiva hecha en Uruguay</h1>
        <p>Somos una empresa uruguaya de fabricación propia de indumentaria urbana y deportiva para mujer, hombre y niños.</p>
        <p>Trabajamos desde Ciudad de la Costa, Canelones, con venta minorista y mayorista y envíos a todo Uruguay.</p>
        <div className="info-page-actions">
          <Link className="info-page-secondary-cta" to="/tienda">Ver productos</Link>
          <WhatsAppCta />
        </div>
      </section>
    </main>
  </>
);

export const WholesalePage = () => (
  <>
    <SEO
      title="Venta mayorista de ropa en Uruguay"
      description="Consultá por venta mayorista de indumentaria urbana y deportiva de fabricación propia de Rem Urban Clothes."
      url="/mayoristas"
      breadcrumbs={[
        { name: 'Inicio', url: '/' },
        { name: 'Mayoristas', url: '/mayoristas' }
      ]}
    />
    <main className="info-page">
      <section className="info-page-content">
        <p className="info-page-eyebrow">Rem Urban Clothes</p>
        <h1>Venta mayorista de ropa de fabricación propia en Uruguay</h1>
        <p>Trabajamos con comercios, revendedores, tiendas, emprendimientos y distribuidores que buscan indumentaria urbana y deportiva.</p>
        <p>Consultanos para conocer las líneas disponibles y coordinar compras mayoristas con envíos a todo Uruguay.</p>
        <div className="info-page-actions">
          <WhatsAppCta label="Consultar por compras mayoristas" />
        </div>
      </section>
    </main>
  </>
);

export const FaqPage = () => (
  <>
    <SEO
      title="Preguntas frecuentes"
      description="Respuestas a las preguntas frecuentes sobre Rem Urban Clothes, compras y atención mayorista."
      url="/preguntas-frecuentes"
      faqItems={FAQ_ITEMS}
      breadcrumbs={[
        { name: 'Inicio', url: '/' },
        { name: 'Preguntas frecuentes', url: '/preguntas-frecuentes' }
      ]}
    />
    <main className="info-page">
      <section className="info-page-content">
        <p className="info-page-eyebrow">Ayuda</p>
        <h1>Preguntas frecuentes</h1>
        <dl className="faq-list">
          {FAQ_ITEMS.map(({ question, answer }) => (
            <div key={question} className="faq-item">
              <dt>{question}</dt>
              <dd>{answer}</dd>
            </div>
          ))}
        </dl>
        <WhatsAppCta />
      </section>
    </main>
  </>
);
